<template>
    <div class="post---flight--reporting-main">
        <div class="box">
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Off Block Time</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <datepicker
                                    :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.IF.offBlockTime" v-model="InputsObject.IF.offBlockTime" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Take-off Time</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <datepicker
                                    :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.IF.takeOffTime" v-model="InputsObject.IF.takeOffTime" disabled/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="field is-horizontal">
                <div class="field-label"><label class="label">Landing Time </label></div>
                <div class="field-body">
                    <div class="field is-expanded">
                        <div class="field has-addons">
                            <p class="control is-expanded">
                                <datepicker
                                        :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.AL.landingTime" v-model="InputsObject.AL.landingTime" disabled/>
                            </p>
                            <p class="control">
                           <span>
                                <a class="button"><i class="fa fa-clock"></i></a>
                           </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label"><label class="label">ON Block Time</label></div>
                <div class="field-body">
                    <div class="field is-expanded">
                        <div class="field has-addons">
                            <p class="control is-expanded">
                                <datepicker :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.AL.onBlockTime" v-model="InputsObject.AL.onBlockTime" disabled/>
                            </p>
                            <p class="control">
                           <span>
                           <a class="button"><i class="fa fa-clock"></i></a>
                           </span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Totals</p></div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Total Airborne Time</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <datepicker :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.AL.totalAirborneTime" v-model="InputsObject.AL.totalAirborneTime" disabled/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Total Block Time</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <datepicker :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.AL.totalBlockTime" v-model="InputsObject.AL.totalBlockTime" disabled/>
<!--                            <input class="input" type="text" disabled>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">LVO</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <datepicker :config="{ dateFormat:'H:i',enableTime:true ,noCalendar:true,time_24hr:true}" v-if="InputsObject.AL.lvoTime" v-model="InputsObject.AL.lvoTime" disabled/>

                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">LVO Type</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <div class="is-fullwidth">
                                <input class="input" type="text"  v-if="InputsObject.AL.lvoType" v-model="InputsObject.AL.lvoType" readonly>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="box">
                <div class="heading has-text-centered is-size-5 has-text-weight-bold">
                    <p>LVO Form Photo (Capture in Portrait mode)</p>
                </div>
                <div v-if="LVOFormShow">
                    <img :src="getLVOForm" @error="errorLVOForm(0)" @load="errorLVOForm(1)" onerror="this.style.display='none'" alt="LVO Form" width="100%" height="100%">
                </div>
                <div v-if="!LVOFormShow">
                    <p>Lvo Form photo couldn't get.</p>
                </div>
            </div>

        </div>

        <div class="box">
            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Landing</p></div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Number of Landings</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input" type="text" v-if="InputsObject.AL.numberOfLandings" v-model="InputsObject.AL.numberOfLandings" readonly>
                        </div>
                    </div>
                </div>
            </div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Training Flight</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control" v-if="InputsObject.AL.trainingFlight">
                            <label class="radio" v-if="InputsObject.AL.trainingFlight == 'true'">
                                <input type="radio" name="answerTraining" checked="true">
                                Yes
                            </label>
                            <label class="radio" v-if="InputsObject.AL.trainingFlight == 'false'" >
                                <input type="radio" name="answerTraining" checked="true">
                                No
                            </label>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="box">
            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Fuel</p></div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Fuel on Blocks(Kg)</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input" type="text" v-if="InputsObject.AL.fuelOnBlocks" v-model="InputsObject.AL.fuelOnBlocks" readonly >
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Fuel Used(Kg) **</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " type="text" v-if="InputsObject.AL.fuelUsed" v-model="InputsObject.AL.fuelUsed" readonly>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="box">
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Planned Fuel Usage (Inc Taxi)</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input" type="text" disabled :value="PlannedFuelUsage">
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Difference</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input" type="text" v-if="InputsObject.AL.difference" v-model="InputsObject.AL.difference" readonly>
                        </div>
                    </div>
                </div>
            </div>
            <div class="has-text-centered">
                <p><em class="title is-size-6">Reason of Difference (> 200 Kg or > 5%)</em></p>
            </div>
            <div>
                <textarea class="textarea" name="" cols="165" rows="5" v-if="InputsObject.AL.reasonOfDifference" v-model="InputsObject.AL.reasonOfDifference" readonly></textarea>
            </div>
        </div>

        <div class="box">
            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Flight Safety Report</p></div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">ASR Sent</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control" v-if="InputsObject.AL.asrSent">
                            <label class="radio" v-if="InputsObject.AL.asrSent == 'true'">
                                <input type="radio" name="answerASR" checked="true">
                                Yes
                            </label>
                            <label class="radio" v-if="InputsObject.AL.asrSent == 'false'">
                                <input type="radio" name="answerASR" checked="true">
                                No
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="box">
            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Services</p></div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Park Position</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " type="text" v-if="InputsObject.AL.parkPosition" v-model="InputsObject.AL.parkPosition"  readonly>
                        </div>
                    </div>
                </div>
            </div>

            <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">GPU</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control" v-if="InputsObject.AL.gpu">
                        <label class="radio" v-if="InputsObject.AL.gpu == 'true'">
                            <input type="radio" name="answerGpu" checked="true">
                            Yes
                        </label>
                        <label class="radio" v-if="InputsObject.AL.gpu == 'false'">
                            <input type="radio" name="answerGpu" checked="true">
                            No
                        </label>
                    </div>
                </div>
            </div>

        </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">ACU</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control" v-if="InputsObject.AL.acu">
                            <label class="radio" v-if="InputsObject.AL.acu == 'true'">
                                <input type="radio" name="answerACU" checked="true">
                                Yes
                            </label>
                            <label class="radio" v-if="InputsObject.AL.acu == 'false'">
                                <input type="radio" name="answerACU" checked="true">
                                No
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">ASU</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control" v-if="InputsObject.AL.asu">
                            <label class="radio" v-if="InputsObject.AL.asu == 'true'">
                                <input type="radio" name="answerASU" checked="true">
                                Yes
                            </label>
                            <label class="radio" v-if="InputsObject.AL.asu == 'false'">
                                <input type="radio" name="answerASU" checked="true">
                                No
                            </label>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="box">

            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Service Notes</p></div>

            <div>
                <textarea placeholder="Write your text here..." class="textarea" name="" cols="165" rows="5" v-if="InputsObject.AL.serviceNotes" v-model="InputsObject.AL.serviceNotes" readonly></textarea>
            </div>

        </div>

        <div class="box">

            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Diversion</p></div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Diversion</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control" v-if="InputsObject.AL.diversion">
                            <label class="radio" v-if="InputsObject.AL.diversion=='true'">
                                <input type="radio" name="answerDiversion" checked="true">
                                Yes
                            </label>
                            <label class="radio" v-if="InputsObject.AL.diversion=='false'">
                                <input type="radio" name="answerDiversion" checked="true">
                                No
                            </label>
                        </div>
                    </div>
                </div>

            </div>


            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Arrival Airport</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " type="text" v-if="InputsObject.AL.arrivalAirport" v-model="InputsObject.AL.arrivalAirport" readonly>
<!--                            Diversion: Yes/No, No ise arrival airport= destination airport. Yes ise boşluk, pilot kendi giriyor.-->
                        </div>
                    </div>
                </div>
            </div>


            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Technical Remark</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control" v-if="InputsObject.AL.technicalRemark">
                            <label class="radio" v-if="InputsObject.AL.technicalRemark=='true'">
                                <input type="radio" name="answerTechnicalR" checked="true">
                                Yes
                            </label>
                            <label class="radio" v-if="InputsObject.AL.technicalRemark=='false'">
                                <input type="radio" name="answerTechnicalR" checked="true">
                                No
                            </label>
                        </div>
                    </div>
                </div>

            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Pilot TakeOff</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
<!--                            <label v-for="(captain,index) in captains" :key="index" class="radio">-->
<!--                                <input v-if="captain" type="radio" name="answerPilotTakeOff">-->
<!--                                {{captain}}-->
<!--                            </label>-->
                            <input class="input " v-if="InputsObject.AL.pilotTakeOff" v-model="InputsObject.AL.pilotLanding" type="text" name="answerPilotTakeOff" readonly>


                        </div>
                    </div>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Pilot Landing</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">

                            <input class="input " v-if="InputsObject.AL.pilotLanding" v-model="InputsObject.AL.pilotLanding" type="text" name="answerPilotLanding" readonly>

                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="box">

            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Flight Type</p></div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Types</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " v-if="InputsObject.AL.flightType" v-model="InputsObject.AL.flightType" type="text" name="answerPilotLanding" readonly>


                        </div>
                    </div>
                </div>

            </div>


            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Other</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " v-if="InputsObject.AL.flightTypeOther" v-model="InputsObject.AL.flightTypeOther" type="text" name="answerPilotLanding" readonly>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="box">

            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Flight Duty</p></div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Duties</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                                <input class="input " v-if="InputsObject.AL.flightDutyType" v-model="InputsObject.AL.flightDutyType" type="text" name="answerflightDutyType" readonly>
                        </div>
                    </div>
                </div>

            </div>


            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Other</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " v-if="InputsObject.AL.flightDutyTypeOther" v-model="InputsObject.AL.flightDutyTypeOther" type="text" name="answerflightDutyTypeOther" readonly>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="box">

            <div class="heading has-text-centered is-size-5 has-text-weight-bold">  <p>Weather on approach (&#60;1000&#96;)</p></div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Options</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control" v-if="InputsObject.AL.weatherOnApproach">
                            <label class="radio" v-if="InputsObject.AL.weatherOnApproach == 'IMC'">
                                <input type="radio" name="answerWeatherOnApproach" checked="true">
                                IMC
                            </label>
                            <label class="radio" v-if="InputsObject.AL.weatherOnApproach == 'VMC'">
                                <input type="radio" name="answerWeatherOnApproach" checked="true">
                                VMC
                            </label>
                        </div>
                    </div>
                </div>

            </div>

        </div>


        <div class="box">

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Executed SID</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " type="text" v-if="InputsObject.AL.executedSID" v-model="InputsObject.AL.executedSID" readonly>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="box">
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Executed STAR</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " type="text" v-if="InputsObject.AL.executedSTAR" v-model="InputsObject.AL.executedSTAR" readonly>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="box">

<!--            <div class="heading has-text-centered is-size-5 has-text-weight-bold">  <p> Takeoff executed by</p></div>-->

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Takeoff executed by</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " type="text" v-if="InputsObject.AL.takeOffExecutedBy" v-model="InputsObject.AL.takeOffExecutedBy" readonly>

                        </div>
                    </div>
                </div>

            </div>


        </div>

        <div class="box">

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Landing executed by</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " type="text" v-if="InputsObject.AL.landingExecutedBy" v-model="InputsObject.AL.landingExecutedBy" readonly>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="box">

            <div class="heading has-text-centered is-size-5 has-text-weight-bold">  <p> Felt Tiredness at the End of the Leg</p></div>

            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label"></label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">

                                <input class="input " type="text" v-if="InputsObject.AL.feltTiredness" v-model="InputsObject.AL.feltTiredness" readonly>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="box">
            <!-- <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Parking Position</p></div> -->
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <label class="label">Parking Position</label>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <input class="input " type="text" v-if="InputsObject.AL.parkPosition" v-model="InputsObject.AL.parkPosition" readonly>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="box">
            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>Datalog (Capture in Portrait mode)</p></div>
            <div>
                <img v-if="datalogShow" :src="getJpegDatalog" @error="errordatalog(0)" @load="errordatalog(1)" onerror="this.style.display='none'" alt="Datalog info" width="100%" height="100%">
            </div>
            <div v-if="!datalogShow">
                <p>Datalog couldn't get.</p>
            </div>
        </div>

        <div class="box">
            <div class="heading has-text-centered is-size-5 has-text-weight-bold">
                <p>Additional Info 1 (Capture in Portrait mode)</p>
            </div>
            <div v-if="additionalInfo1Show">
                <img :src="getJpegAdditionalInfo1" @error="errorAdditionalInfo1(0)" @load="errorAdditionalInfo1(1)" onerror="this.style.display='none'" alt="Additional Info 2" width="100%" height="100%">
            </div>
            <div v-if="!additionalInfo1Show">
                <p>Additional Info couldn't get.</p>
            </div>
        </div>

        <div class="box">
            <div class="heading has-text-centered is-size-5 has-text-weight-bold">
                <p>Additional Info 2 (Capture in Portrait mode)</p>
            </div>
            <div v-if="additionalInfo2Show" class="content" :class = "{hide : !Jpegshow}">
                <img :src="getJpegAdditionalInfo2" @error="errorAdditionalInfo2(0)" @load="errorAdditionalInfo2(1)" onerror="this.style.display='none'" alt="Additional Info 2" width="100%" height="100%">
            </div>
            <div v-if="!additionalInfo2Show">
                <p>Additional Info 2 couldn't get.</p>
            </div>
        </div>

<!--        <div class="box">-->
<!--            <div class="heading has-text-centered is-size-5 has-text-weight-bold"><p>PIC Sign</p></div>-->
<!--            <div>-->
<!--                <textarea class="textarea" name="" cols="165" rows="5" readonly>I hereby certify that the data I have filled out is true.</textarea>-->
<!--            </div>-->
<!--            <div v-if="signatureShow">-->
<!--                 <img :src="getSvgSignature" @error="errorsignature(0)" @load="errorsignature(1)" onerror="this.style.display='none'" width="300px" height="200px" alt="Signature">-->
<!--            </div>-->
<!--            <div v-if="!signatureShow">-->
<!--                <p>Signature couldn't get.</p>-->
<!--            </div>-->
<!--        </div>-->

<!--            <div class="field is-horizontal">-->
<!--                <div class="field-label is-normal">-->
<!--                    <label class="label">PIC Sign</label>-->
<!--                </div>-->
<!--                <div class="field-body">-->
<!--                    <div class="field">-->
<!--                        <div class="control">-->
<!--                            <input class="input is-danger" type="text" disabled>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--    -->
<!--            <div class="field is-horizontal">-->
<!--                <div class="field-label is-normal">-->
<!--                    <label class="label">Password</label>-->
<!--                </div>-->
<!--                <div class="field-body">-->
<!--                    <div class="field">-->
<!--                        <div class="control">-->
<!--                            <input class="input is-danger" type="text" disabled>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

    </div>
</template>

<script>

    import Datepicker from "vue-bulma-datepicker"
    import {loadingMixin} from "../../../utils/mixins";
    import {/*mapActions,*/ mapState} from "vuex";
    import {createUrl} from "../../../http";

    export default {
        name: "PostFlightReporting",

        props: ["id", "flight"],

        mixins: [loadingMixin],

        data() {
            return {
                fueldata :"",
                plannedfuelusage : 0,
                captains : [],
                diversionStat : false,
                Jpegshow : true,
                LVOFormShow : true,
                datalogShow : true,
                additionalInfo1Show : true,
                additionalInfo2Show : true,
                signatureShow : true,
                activeJpegUrl : createUrl('/EffIpadPreview/GetInputJpeg/'),
                activeSvgUrl : createUrl('/EffIpadPreview/GetInputSVG/'),
                getJpegDatalog : "",
                getJpegAdditionalInfo1 : "",
                getJpegAdditionalInfo2 : "",
                getSvgSignature:"",
                getLVOForm :"",
            }
        },

        computed : {
            ...mapState("ipadmain",[ "ActiveDevice_UID","selectedFlightItems","EFF_Json_Data","WR_Json_Data","AttachmentsJson","OCCSelfVersions_VS_IPADLastKnownVersions","LastInputsJson","InputsObject"]),

            PlannedFuelUsage : function ()
            {
                return this.EFF_Json_Data.poFuel.TaxiFuelEstimatedWeightKg + this.EFF_Json_Data.poFuel.TripFuelEstimatedWeightKg ;
            },
        },

        components: {
            Datepicker
        },

        async created()
        {
            this.getJpegDatalog = this.activeJpegUrl + this.id + "/" + this.flight.std + "/"+this.ActiveDevice_UID+"/" + "AL_Datalog.jpg"+"/"+this.flight.flightArchiveStat;
            this.getJpegAdditionalInfo1 = this.activeJpegUrl + this.id + "/" + this.flight.std +"/"+this.ActiveDevice_UID+"/"  + "AL_AdditionalInfo1.jpg"+"/"+this.flight.flightArchiveStat;
            this.getJpegAdditionalInfo2 = this.activeJpegUrl + this.id + "/" + this.flight.std + "/"+this.ActiveDevice_UID+"/" + "AL_AdditionalInfo2.jpg"+"/"+this.flight.flightArchiveStat;
            this.getLVOForm = this.activeJpegUrl + this.id + "/" + this.flight.std + "/" +this.ActiveDevice_UID+"/"+ "AL_LVO.jpg"+"/"+this.flight.flightArchiveStat;
            this.getSvgSignature = this.activeSvgUrl + this.id + "/" + this.flight.std+ "/" +this.ActiveDevice_UID+"/"+ "AL_Signature.svg"+"/"+this.flight.flightArchiveStat;

            this.GetCaptains();
        },

        methods: {

            errorLVOForm(stat)
            {
                if(stat == 0)
                {
                    this.LVOFormShow = false;
                }
                else if(stat ==1)
                {
                    this.LVOFormShow = true;
                }
            },

            errorAdditionalInfo1(stat)
            {
                if(stat == 0)
                {
                    this.additionalInfo1Show = false;
                }
                else if(stat ==1)
                {
                    this.additionalInfo1Show = true;
                }
            },

            errorAdditionalInfo2(stat)
            {
                if(stat == 0)
                {
                    this.additionalInfo2Show = false;
                }
                else if(stat ==1)
                {
                    this.additionalInfo2Show = true;
                }
            },

            errordatalog(stat)
            {
                if(stat == 0)
                {
                    this.datalogShow = false;
                }
                else if(stat ==1)
                {
                    this.datalogShow = true;
                }
            },

            errorsignature(stat)
            {
                if(stat == 0)
                {
                    this.signatureShow = false;
                }
                else if(stat ==1)
                {
                    this.signatureShow = true;
                }
            },


            GetCaptains()
            {

                  this.captains.push(this.flight.cP1);
                  this.captains.push(this.flight.cP2);
                  this.captains.push(this.flight.cP3);

            },

            // async saveForm() {
            //     this.showLoading();
            //     try {
            //         await setTimeout(3000);
            //     } finally {
            //         this.hideLoading();
            //         this.$notify({title: "Success", type: "success", text: "Successfully"})
            //     }
            // },

        }
    }
</script>

<style scoped>
    .textarea{
        margin-top: 15px;
    }

</style>
